import InfoRow from '../InfoRow'
import DeliveryZoneInfo from '@/features/orders/components/OrderListItem/parts/OrderMetaInfo/parts/DeliveryZoneInfo'
import { channelIconMap } from '@/features/orders/components/OrderListItem/utils/iconMaps'
import { Order } from '@/features/orders/types/app'
import { FC } from 'react'

interface ChannelRowProps {
    channel: Order['channel']
    deliveryZone?: Order['deliveryZone']
}

const ChannelRow: FC<ChannelRowProps> = ({ channel, deliveryZone }) => {
    const channelIcon = channelIconMap[channel]

    if (!channelIcon) return null

    return (
        <InfoRow
            Icon={channelIcon}
            content={deliveryZone ? <DeliveryZoneInfo {...deliveryZone} /> : null}
        />
    )
}

export default ChannelRow
